import React from 'react';
import isWeb from '../../../utils/isWeb';
import {Center} from 'native-base';
import {
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  View,
  useWindowDimensions,
} from 'react-native';

type ScreenWrapperProps = {
  children: any;
  alignTop?: boolean;
};

export default function ScreenWrapper({children, alignTop = false}: ScreenWrapperProps) {
  const {height} = useWindowDimensions();
  const isCompactIosAuthScreen =
    Platform.OS === 'ios' && alignTop && height <= 812;

  if (isWeb) {
    return (
      <ScrollView contentContainerStyle={{flexGrow: 1}}>
        <Center>{children}</Center>
      </ScrollView>
    );
  }
  return (
    <KeyboardAvoidingView
      behavior={
        Platform.OS === 'ios'
          ? isCompactIosAuthScreen
            ? 'height'
            : 'padding'
          : 'height'
      }
      enabled
      keyboardVerticalOffset={0}
      style={{
        flex: 1,
        paddingTop: Platform.OS === 'ios' && !alignTop ? 24 : 0,
      }}>
      <View
        style={{
          flex: 1,
          justifyContent: alignTop ? 'flex-start' : 'center',
        }}>
        {children}
      </View>
    </KeyboardAvoidingView>
  );
}
